module.exports = __webpack_public_path__ + "img/PDF.5ca6190.webp";